<div class="environment-switcher" [class.is-prod]="isProd()">Using {{ getEnvName() }}</div>
